import { BreadBudget } from "breadcommon";
import { buildClasses } from "../utils/buildClasses";
import { BudgetTrackingTable } from "./BudgetTrackingTable";
import { ColumnVisibility } from "./BudgetTrackingReport";

export function BudgetTracker(props: {
  budget: BreadBudget;
  columnVisibility: ColumnVisibility;
}): JSX.Element {
  return (
    <div className={buildClasses("flex", "flex-col", "pt-8")}>
      <BudgetTrackingTable
        budget={props.budget}
        columnVisibility={props.columnVisibility}
      />
    </div>
  );
}
